import { clsx } from 'clsx'
import { Shimmer } from 'react-shimmer'

import type { GetInternalActionExecutionLogByIdResponse } from '~/generated/client'
import {
  Badge,
  blockHeadingStyle,
  blockSubHeadingStyle,
  Dot,
  LineHeading,
} from '../components/common'
import { TabComponent } from '../components/tab'

export const ActionResultBlock = ({
  logData,
}: {
  logData: GetInternalActionExecutionLogByIdResponse
}) => {
  const responseVal = logData?.response || logData?.error
  const status =
    responseVal?.status || logData?.status === 'success' ? '200' : '500'

  const response = [
    {
      key: 'response',
      heading: 'RESPONSE',
      isJSON: true,
      content: JSON.stringify(responseVal),
    },
  ]
  return (
    <div className="ds-flex ds-items-center ds-gap-2 relative w-full pb-[60px]">
      <Dot size={14} status={status === '200' ? 'success' : 'error'} />
      <div className="w-full pl-[8px]">
        <div className="flex w-full flex-col gap-1">
          <div className="flex items-center gap-2">
            <div
              className={clsx(
                blockHeadingStyle,
                'mt-[-6px] flex w-full items-center justify-between',
              )}
            >
              <LineHeading />
              {!logData ? (
                <Shimmer width={200} height={20} />
              ) : (
                'Tool returned with following result'
              )}
              {!logData ? (
                <Shimmer width={50} height={20} />
              ) : (
                <Badge
                  state={status === '200' ? 'success' : 'error'}
                  className="ds-text-12 ds-font-500 mb-[4px] max-h-[24px]"
                >
                  {status === '200' ? 'Success' : 'Error'}
                </Badge>
              )}
            </div>
          </div>
          <div
            className={clsx(blockSubHeadingStyle, 'flex justify-between pr-4')}
          >
            {!logData ? (
              <Shimmer width={260} height={20} />
            ) : (
              <span>Response returned to the client</span>
            )}
            {!logData ? (
              <Shimmer width={100} height={20} />
            ) : (
              <span>Overall time: {logData.totalDuration}ms</span>
            )}
          </div>
          <div className="ds-mt-12 pr-[12px]">
            {!logData ? (
              // @ts-expect-error using percentage it works
              <Shimmer width={'100%'} height={260} />
            ) : (
              <TabComponent tabs={response} selectedTab="response" />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
